import { useMemo } from 'react';
import {
	WorkingHoursDay,
	useServiceScheduleContext,
} from '../../WorkplaceMember/Services/ServiceScheduleContext';
import { Moment } from 'moment';
import { RadioListItem } from '../../../Components/Form/components/RadioList';
import { ServiceScheduleType } from '../../../graphql/graphql';
import { getMomentDate } from '../../../Utils/dates.util';
import useTranslation from '../../../Hooks/useTranslation';
import moment from 'moment';

export default function useWorkingHours(date: Moment | string) {
	const { workingHours, workingHoursExtra } = useServiceScheduleContext();
	const { t } = useTranslation();

	const dayIndex = getMomentDate(date).day();

	const workingHoursByDayIndex: Record<number, WorkingHoursDay | null> = {
		1: workingHours.mon,
		2: workingHours.tue,
		3: workingHours.wed,
		4: workingHours.thu,
		5: workingHours.fri,
		6: workingHours.sat,
		7: workingHours.sun,
		0: workingHours.sun,
	};

	const workingHoursExtraByDayIndex: Record<number, WorkingHoursDay | null> = {
		1: workingHoursExtra.mon,
		2: workingHoursExtra.tue,
		3: workingHoursExtra.wed,
		4: workingHoursExtra.thu,
		5: workingHoursExtra.fri,
		6: workingHoursExtra.sat,
		7: workingHoursExtra.sun,
		0: workingHoursExtra.sun,
	};

	const workingHoursDay = workingHoursByDayIndex[dayIndex];
	const workingHoursExtraDay = workingHoursExtraByDayIndex[dayIndex];

	const getTimes = (
		workingHoursDay: WorkingHoursDay,
	): { timeFrom: Moment; timeTo: Moment } => {
		return {
			timeFrom: moment(workingHoursDay.timeFrom, 'HH:mm'),
			timeTo: moment(workingHoursDay.timeTo, 'HH:mm'),
		};
	};

	const getTimesByShiftType = (
		type: ServiceScheduleType,
	): { timeFrom: Moment; timeTo: Moment } | undefined => {
		if (type === ServiceScheduleType.Shift && workingHoursDay) {
			return getTimes(workingHoursDay);
		} else if (
			type === ServiceScheduleType.ShiftExtra &&
			workingHoursExtraDay
		) {
			return getTimes(workingHoursExtraDay);
		}
		return undefined;
	};

	const getTitle = (defaultTitle: string, workingHoursDay: WorkingHoursDay) => {
		const { timeFrom, timeTo } = getTimes(workingHoursDay);
		return `${defaultTitle} (${timeFrom.format('HH:mm')}  - ${timeTo.format(
			'HH:mm',
		)})`;
	};

	const workingHoursOptions: RadioListItem[] = useMemo(() => {
		let workingHoursTitle = t('base.shared.officeHours');

		if (workingHoursDay) {
			workingHoursTitle = getTitle(workingHoursTitle, workingHoursDay);
		}
		return [
			{
				value: ServiceScheduleType.Shift,
				title: workingHoursTitle,
			},
		];
	}, []);

	return { workingHoursOptions, getTimesByShiftType };
}
